module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n<!-- src/app/employer/templates/reports/Variance.ejs -->\n<div class="row wrapper border-bottom white-bg page-heading">\n    <div class="col-xs-12">\n        <h2> Reports </h2>\n    </div>\n</div>\n\n<div class="wrapper wrapper-content">\n    <div class="row">\n        <div class="col-md-12 col-lg-12">\n            <div class="ibox float-e-margins">\n\n                <div class="ibox-title">\n                    <h3>Variance</h3>\n                </div>\n\n                <div class="ibox-content">\n                    '+
((__t=( data ))==null?'':__t)+
'\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/employer/templates/reports/Variance.ejs
// module id = 832
// module chunks = 1